import { useRef } from "react";
import * as StateLib from "@/Utils/StateLib";
import FieldToggleMenu from "@/appComponents/Blocks/Menus/FieldToggleMenu/FieldToggleMenu";
import { Button } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";
import { ApplyChartTemplateToDocMgr } from "@coreapp/utils/ApplyChartTemplateToDocMgr";
import { getFeatureAccess } from "@/Utils/Misc";
import { enumFeaturesList } from "@coreapp/constants";

const FieldDisplayMenu = () => {
  const openCtrlRef = useRef(null);
  let wsMgr = StateLib.GetWSMgr();
  let doc = StateLib.GetDoc();
  if (!doc) return;

  let viewMgr = doc.GetViewMgr();
  if (!viewMgr) return;

  let [rootLayout, fallback] = viewMgr.GetRootLayout();
  let activeFields = rootLayout.GetUsedFields();
  let selectedFieldNames = activeFields.map(function (a) {
    return a.GetFieldName();
  });
  let fieldNames = viewMgr.GetFieldList();

  if (doc.IsCustomChart()) {
    // Non-serializable live calc fields (_Headcount etc.) can't be persisted in the profile JSON,
    // so GetFieldList() never returns them. Supplement from the class's live field list.
    const profileSet = new Set(fieldNames);
    doc.GetFieldList2(true, true, false, false).forEach(f => {
      if (!f.IsSerializable()) {
        const name = f.GetFieldName();
        if (!profileSet.has(name)) {
          fieldNames = [...fieldNames, name];
          profileSet.add(name);
        }
      }
    });
  }
  const ToggleField = target => {
    let newFieldList = selectedFieldNames ? selectedFieldNames.slice(0) : [];
    let targetField = target.value;
    let targetIdx = selectedFieldNames.indexOf(targetField);
    if (targetIdx > -1) newFieldList.splice(targetIdx, 1);
    else newFieldList.push(targetField);

    viewMgr.fFieldList = newFieldList;
    viewMgr.HandleUpdateBox();
    ApplyChartTemplateToDocMgr(doc.GetActiveTemplate(), wsMgr, null, doc, false);
    wsMgr.ReloadCurrentSubChart(false);
    StateLib.ReRenderCanvas();
  };

  const fieldTrigger = (
    <Button
      modifier="secondary"
      type="button"
      tooltipProps={{ message: appstr("Fields"), referenceOpenCtrlRef: openCtrlRef }}
      id={"mtb-fields-menu"}
      disabled={!getFeatureAccess(enumFeaturesList.interactiveFieldToggle)}
    >
      {appstr("Fields")}
    </Button>
  );

  return (
    <span>
      <FieldToggleMenu
        openCtrlRef={openCtrlRef}
        selectedFieldNames={selectedFieldNames.sort()}
        fieldNames={fieldNames.sort()}
        onChange={ToggleField}
        dataTestIdPrefix={"chart-mode-toolbar-toggle-field-"}
        trigger={fieldTrigger}
        listHeader={{
          label: appstr("Show fields")
        }}
        listProps={{
          maxHeight: "440px",
          inputProps: { dataTestId: "chart-mode-toolbar-field-search" }
        }}
        position="bottom-start"
        listWidth={"large"}
        stayAlive={true}
        fillWidth={true}
      />
    </span>
  );
};

export default FieldDisplayMenu;
